import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
// import Header from "../components/Header"; // Header is now in MainReportsDashboard

function NutritionReports({ locationData, isSearchApplied }) { // Accept props
  //console.log(locationData)
  const [reportData, setReportData] = useState({
    "Family Profile (BNS Form No. 1A) complete enumeration": [],
    "Family Profile (BNS Form No. 1A) with children < 6": [],
    "BNS Form 1B": [],
    "OPT Plus Form 1B": [],
    "BNS Form No. 3A": [],
    "Underweight Children Without Sanitary Toilet": [],
    "Underweight Children with Incomplete Immunization, 12-23 months": [],
    "Underweight Children with No Immunization, 0-1 months": [],
    "Underweight Children Not Dewormed": [],
    "Underweight Children Without Backyard Garden": [],
    "Underweight Children with Large (>5) Family Size": [],
    "Underweight Children Without Potable Water Supply": [],
    "Underweight Children Without Proper Garbage Disposal": [],
    "Malnourished Children with family per capita income below poverty threshold but above food threshold": [],
    "Malnourished Children with family per capita income below food threshold": [],
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Removed local state for searchQuery and isSearchApplied
  
  const [selectedNNCForm, setSelectedNNCForm] = useState(''); 

  const reportConfig = {
    "Family Profile (BNS Form No. 1A) complete enumeration": {
      type: 1,
      keys: ["hh_no", "purok_sitio", "no_household_members", "count_6_mos", "count_6_23_mos", "count_2_5_years", "count_5_6_years", "name", "other_income_source", "level_id", "pregnant", "contraceptives_used", "ebf", "mixed_feeding", "bottle_fed", "others", "facility_type", "concatenated_source_types", "fp_activity", "salt", "ifr"]
    },
    "Family Profile (BNS Form No. 1A) with children < 6": {
      type: 2,
      keys: ["hh_no", "purok_sitio", "no_household_members", "count_6_mos", "count_6_23_mos", "count_2_5_years", "count_5_6_years", "name", "other_income_source", "level_id", "pregnant", "contraceptives_used", "ebf", "mixed_feeding", "bottle_fed", "others", "facility_type", "concatenated_source_types", "fp_activity", "salt", "ifr"]
    },
    "BNS Form 1B": {
      type: 3,
      keys: [
        "hh_no",
        "name_household_head_spouse",
        "name_of_child",
        "birth_and_opt_date",
        "age_in_months",
        "height",
        "weight",
        "wa",
        "ha",
        "wh",
        "practicing_ebf",
        "practicing_cf",
        "cf_age_in_months",
        "beneficiary_of_sf",
        "vitA_date_received",
        "iron",
        "mnp",
        "purok_sitio"
      ]
    },
    "OPT Plus Form 1B": {
      type: 4,
      keys: ["purok", "hh_no", "name_hh_head", "name_preschooler", "sex", "i_group", "age_in_months", "uw", "suw", "st","sst", "w", "sw", "ow", "ob"]
    },
    "BNS Form No. 3A": {
      type: 5,
      keys: [
        "no",
        "name_of_child",
        "birthdate",
      ]
    },
    "Underweight Children Without Sanitary Toilet": { type: 6, keys: ["purok", "hh_no", "street", "family_head_name", "name_of_child", "age_in_months", "WA", "HA", "WH", "facility_type"] }, 
    "Underweight Children with Incomplete Immunization, 12-23 months": { type: 7, keys: ["purok", "head_id", "street", "family_head_name", "name_of_child", "age_in_months", "WA", "HA", "WH", "facility_type"] },
    "Underweight Children with No Immunization, 0-1 months": { type: 8, keys: ["purok", "head_id", "street", "family_head_name", "name_of_child", "age_in_months", "WA", "HA", "WH", "facility_type"] },
    "Underweight Children Not Dewormed": { type: 9, keys: ["purok", "head_id", "street", "family_head_name", "name_of_child", "age_in_months", "WA", "HA", "WH", "facility_type"] },
    "Underweight Children Without Backyard Garden": { type: 10, keys: ["purok", "head_id", "street", "family_head_name", "name_of_child", "age_in_months", "WA", "HA", "WH", "facility_type"] },
    "Underweight Children with Large (>5) Family Size": { type: 11, keys: ["purok", "head_id", "street", "family_head_name", "name_of_child", "age_in_months", "WA", "HA", "WH", "facility_type"] },
    "Underweight Children Without Potable Water Supply": { type: 12, keys: ["purok", "hh_no", "street", "head_name", "child_name", "age_in_mos", "WA", "HA", "WH", "source"] }, 
    "Underweight Children Without Proper Garbage Disposal": { type: 13, keys: ["purok", "head_id", "street", "family_head_name", "name_of_child", "age_in_months", "WA", "HA", "WH", "disposal_method"] },
    "Malnourished Children with family per capita income below poverty threshold but above food threshold": { type: 14, keys: ["purok", "hh_no", "street", "head_name", "child_name", "age_in_mos", "WA", "HA", "WH", "per_capita_income"] },
    "Malnourished Children with family per capita income below food threshold": { type: 15, keys: ["purok", "hh_no", "street", "head_name", "child_name", "age_in_mos", "WA", "HA", "WH", "per_capita_income"] },
  };

  const nncReportTypes = [
    "Underweight Children Without Sanitary Toilet",
    "Underweight Children with Incomplete Immunization, 12-23 months",
    "Underweight Children with No Immunization, 0-1 months",
    "Underweight Children Not Dewormed",
    "Underweight Children Without Backyard Garden",
    "Underweight Children with Large (>5) Family Size",
    "Underweight Children Without Potable Water Supply", 
    "Underweight Children Without Proper Garbage Disposal",
    "Malnourished Children with family per capita income below poverty threshold but above food threshold",
    "Malnourished Children with family per capita income below food threshold",
  ];

  // Define specific titles for each NNC report
  const nncReportTitles = {
    "Underweight Children Without Sanitary Toilet": "Listahan ng mga batang mababa ang timbang na walang maayos at sariling palikuran",
    "Underweight Children with Incomplete Immunization, 12-23 months": "Mga batang hindi kompleto ang bakuna at mababa ang timbang (12-23 buwan)",
    "Underweight Children with No Immunization, 0-1 months": "Mga batang walang bakuna at mababa ang timbang (0-11 buwan)",
    "Underweight Children Not Dewormed": "Mga batang mababa ang timbang na hindi pa napupurga",
    "Underweight Children Without Backyard Garden": "Mga batang mababa ang timbang na walang gulayan sa likod bahay",
    "Underweight Children with Large (>5) Family Size": "Mga batang mababa ang timbang na may malaking pamilya",
    "Underweight Children Without Potable Water Supply": "Mga batang mababa ang timbang na walang maayos at malinis na pinagkukunan ng tubig", 
    "Underweight Children Without Proper Garbage Disposal": "Mga batang mababa ang timbang na walang maayos na pagtatapon ng basura",
    "Malnourished Children with family per capita income below poverty threshold but above food threshold": "Mga batang mababa ang timbang below poverty threshold but above food threshold",
    "Malnourished Children with family per capita income below food threshold": "Mga batang mababa ang timbang below food threshold",
  };

  // Modified fetchData to handle fetching all initial reports or a specific one
  const fetchData = async (locationData, labelToFetch = null) => {
    //console.log('fetching')
    try {
      const { provinceName, municipalName, barangayName } = locationData;
      
      setLoading(true);
      setError(null);

      const baseUrl = `${process.env.REACT_APP_API_URL}/api/locations/api/reports/nutrition`;
      const fetchedDataUpdates = {}; // To store data for multiple or single reports

      // Determine which labels to fetch: all if no specific label, else just the specific one
      const labelsToProcess = labelToFetch
        ? [labelToFetch] 
        : Object.keys(reportConfig); 

      for (const label of labelsToProcess) {
        const config = reportConfig[label];
        if (!config) {
          console.warn(`No configuration found for report label: ${label}`);
          continue;
        }
        const location = `${provinceName}_${municipalName}_${barangayName}`
        let url = `${baseUrl}?location=${location}&type=${config.type}`;

        const response = await fetch(url, {
          method: 'GET', 
          headers: {
            'x-api-key': process.env.REACT_APP_API_KEY
          }
        });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const dataObjects = await response.json();

        let processedTableBody = [];

        if (label.startsWith("Family Profile (BNS Form No. 1A)") || label === "BNS Form 1B") {
          const groupedByPurok = new Map();

          dataObjects.forEach(item => {
            const purokSitio = item.purok_sitio;
            if (!groupedByPurok.has(purokSitio)) {
              groupedByPurok.set(purokSitio, []);
            }
            groupedByPurok.get(purokSitio).push(item);
          });

          const sortedPurokSitios = Array.from(groupedByPurok.keys()).sort((a, b) => {
            // Safely convert a and b to strings before calling replace
            const strA = String(a || ''); 
            const strB = String(b || ''); 

            const numA = parseInt(strA.replace(/\D/g, ''), 10) || 0;
            const numB = parseInt(strB.replace(/\D/g, ''), 10) || 0;
            if (numA !== numB) {
              return numA - numB;
            }
            return strA.localeCompare(strB);
          });

          processedTableBody = sortedPurokSitios.map(purok => {
            const itemsInPurok = groupedByPurok.get(purok);
            let rowsForPurok = [];

            if (label.startsWith("Family Profile (BNS Form No. 1A)")) {
                const groupedByPurokAndHead = new Map();
                itemsInPurok.forEach(item => {
                    const headId = item.hh_no;
                    if (!groupedByPurokAndHead.has(headId)) {
                        groupedByPurokAndHead.set(headId, {
                            ...item,
                            _memberNames: []
                        });
                    }
                    if (item.name) {
                        groupedByPurokAndHead.get(headId)._memberNames.push(item.name);
                    }
                });

                rowsForPurok = Array.from(groupedByPurokAndHead.values()).map(householdRowData => {
                    const row = config.keys.map(key => {
                        if (key === "name") {
                            return householdRowData._memberNames.join('\n');
                        }
                        if (key === "purok_sitio") {
                            return undefined;
                        }
                        if (householdRowData[key] && (key.includes("date") || key.includes("Date"))) {
                            try {
                                if (!isNaN(new Date(householdRowData[key]).getTime())) {
                                    return new Date(householdRowData[key]).toLocaleDateString('en-US');
                                }
                            } catch (e) {
                                console.warn(`Invalid date for key ${key}: ${householdRowData[key]}`, e);
                            }
                        }
                        return householdRowData[key];
                    }).filter(val => val !== undefined);
                    return row;
                });

            } else { // For BNS Form 1B
                rowsForPurok = itemsInPurok.map(obj => {
                    const row = config.keys.map(key => {
                        if (key === "height") {
                            const heightValue = parseFloat(obj[key]);
                            if (!isNaN(heightValue)) {
                                return heightValue.toFixed(2);
                            }
                            return obj[key];
                        }
                        if (key === "weight") {
                            const weightValue = parseFloat(obj[key]);
                            if (!isNaN(weightValue)) {
                                return weightValue.toFixed(2);
                            }
                            return obj[key];
                        }
                        if (key === "purok_sitio") {
                            return undefined;
                        }
                        if (obj[key] && (key.includes("date") || key.includes("Date")) && key !== "birth_and_opt_date") {
                            try {
                                if (!isNaN(new Date(obj[key]).getTime())) {
                                    return new Date(obj[key]).toLocaleDateString('en-US');
                                }
                            } catch (e) {
                                console.warn(`Invalid date for key ${key}: ${obj[key]}`, e);
                            }
                        }
                        return obj[key];
                    }).filter(val => val !== undefined);
                    return row;
                });
            }
            return { purok: purok, rows: rowsForPurok };
          });

        } else { 
          processedTableBody = dataObjects.map(obj => config.keys.map(key => {
            if (label === "BNS Form No. 3A" && (key.startsWith("birthdate") || key.startsWith("date_weighing"))) {
                if (obj[key]) {
                    try {
                        if (!isNaN(new Date(obj[key]).getTime())) {
                            return new Date(obj[key]).toLocaleDateString('en-US');
                        }
                    } catch (e) {
                        console.warn(`Invalid date for key ${key}: ${obj[key]}`, e);
                    }
                }
                return obj[key];
            }
            // Handle date formatting for the new 10 reports if needed
            if (nncReportTypes.includes(label) && (key.includes("date") || key.includes("birthdate"))) {
                if (obj[key]) {
                    try {
                        if (!isNaN(new Date(obj[key]).getTime())) {
                            return new Date(obj[key]).toLocaleDateString('en-US');
                        }
                    } catch (e) {
                        console.warn(`Invalid date for key ${key}: ${obj[key]}`, e);
                    }
                }
                return obj[key];
            }
            if (label === "OPT Plus Form 1B" && key === "name_household_head_spouse") {
                return obj[key];
            }
            if (label === "OPT Plus Form 1B" && key === "name_of_preschooler") {
                 return obj[key];
            }

            if (obj[key] && (key.includes("date") || key.includes("Date"))) {
              try {
                if (!isNaN(new Date(obj[key]).getTime())) {
                  return new Date(obj[key]).toLocaleDateString('en-US');
                }
              } catch (e) {
                console.warn(`Invalid date for key ${key}: ${obj[key]}`, e);
              }
            }
            return obj[key];
          }));
        }
        fetchedDataUpdates[label] = processedTableBody;
      }

      // Only update specific report data that was fetched
      setReportData(prevData => ({ ...prevData, ...fetchedDataUpdates }));
    } catch (err) {
      setError(err);
      console.error("Error fetching data:", err);
      // It's generally better to clear only the specific report's data on error, not all
      if (labelToFetch) {
        setReportData(prevData => ({ ...prevData, [labelToFetch]: [] }));
      } else {
        // If fetching all, clear all in case of a general error
        setReportData(Object.fromEntries(Object.keys(reportData).map(key => [key, []]))); 
      }
    } finally {
      setLoading(false);
    }
  };

  // NEW useEffect to fetch all data when isSearchApplied becomes true
  useEffect(() => {
    if (isSearchApplied && locationData && locationData.barangayName) {
      // Clear existing report data before fetching new data for the new search
      setReportData(Object.fromEntries(Object.keys(reportData).map(key => [key, []]))); 
      fetchData(locationData); // Fetch all data when search is applied
    }
  }, [isSearchApplied, locationData]); // Depend on isSearchApplied and locationData

  const handlePreview = (label) => {
    // Now just use the already fetched data
    if (reportData[label] && reportData[label].length > 0) {
        const doc = new jsPDF("landscape", "pt", "A4");
        generateReportContent(locationData, doc, label); // Pass locationData to generateReportContent
        doc.output("dataurlnewwindow");
    } else {
        alert(`No data available for ${label} in ${locationData.barangayName}. You might need to refine your search or the data might not exist.`);
    }
  };

  const handleDownload = (label) => {
    const filename = `${locationData.barangayName}_${locationData.municipalName}_${locationData.provinceName}`
    
    // Now just use the already fetched data
    if (reportData[label] && reportData[label].length > 0) {
        const doc = new jsPDF("landscape", "pt", "A4");
        generateReportContent(locationData, doc, label); // Pass locationData to generateReportContent
        doc.save(`${label.replace(/\s+/g, "_")}_${filename}.pdf`);
    } else {
        alert(`No data available for ${label} in ${filename}. You might need to refine your search or the data might not exist.`);
    }
  };

  const handleNNCFormAction = (actionType) => {
    const filename = `${locationData.barangayName}_${locationData.municipalName}_${locationData.provinceName}`
    if (!selectedNNCForm) {
      alert('Please select a Form from the dropdown.');
      return;
    }
    // Now just use the already fetched data
    if (reportData[selectedNNCForm] && reportData[selectedNNCForm].length > 0) {
        const doc = new jsPDF("landscape", "pt", "A4");
        generateReportContent(locationData, doc, selectedNNCForm); // Pass locationData to generateReportContent
        if (actionType === 'preview') {
            doc.output("dataurlnewwindow");
        } else if (actionType === 'download') {
            doc.save(`${selectedNNCForm.replace(/\s+/g, "_")}_${filename}.pdf`);
        }
    } else {
        alert(`No data available for ${selectedNNCForm} in ${locationData.barangayName}.`);
    }
  };

  const generateReportContent = (locationData, doc, label) => { // Added locationData as a parameter
    const { provinceName, municipalName, barangayName } = locationData;
    console.log("Generating report for:", label);

    let head = [];
    let columnStyles = {};
    let bodyData = reportData[label] || []; 

    // Helper function to get formatted date
    const getFormattedDate = () => {
      const today = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      return today.toLocaleDateString('en-US', options);
    };

    switch (label) {
      case "Family Profile (BNS Form No. 1A) complete enumeration":
      case "Family Profile (BNS Form No. 1A) with children < 6":
        const form1AHead = [
          [
            { content: "HH No", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "No. of HH Members", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "No. of children", colSpan: 4, styles: { halign: 'center', valign: 'middle' } },
            { content: "Name of HH Head/Spouse", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "Occupation", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "Educational Attainment", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "Check if:", colSpan: 2, styles: { halign: 'center', valign: 'middle' } },
            { content: "Check if:", colSpan: 4, styles: { halign: 'center', valign: 'middle' } },
            { content: "Fill in:", colSpan: 3, styles: { halign: 'center', valign: 'middle' } },
            { content: "Check if HH:", colSpan: 2, styles: { halign: 'center', valign: 'middle' } }
          ],
          [
            "<6 mos old",
            "6-23 mos old",
            "24-59 mos old",
            "60-71 mos old", 
            "Mother Pregnant",
            "Practice Family Planning",
            "EBF",
            "Mixed Feeding",
            "Bottlefed",
            "Others",
            "Toilet Type",
            "Water Source Types",
            "Food Prodn Activity",
            "Using Iodized Salt",
            "Using IFR"
          ]
        ];

        const form1AColumnStyles = {
          0: { valign: 'middle' },
          1: { cellWidth: 20 , valign: 'middle'},
          2: { cellWidth: 20 , valign: 'middle'},
          3: { cellWidth: 20 , valign: 'middle'},
          4: { cellWidth: 20 , valign: 'middle'},
          5: { cellWidth: 20 , valign: 'middle'},
          6: { cellWidth: 100 , halign: 'left'},
          7: { cellWidth: 80 , halign: 'left'},
          9: { valign: 'middle' },
          10: { valign: 'middle'},
          11: { cellWidth: 25 , valign: 'middle'},
          12: { cellWidth: 25 , valign: 'middle'},
          13: { cellWidth: 25 , valign: 'middle'},
          14: { cellWidth: 25 , valign: 'middle'},
          15: { halign: 'left'},
          16: { cellWidth: 90 , halign: 'left'},
          17: { cellWidth: 30 },
          18: { cellWidth: 30 }
        };

        (reportData[label] || []).forEach((purokGroup, index) => {
          if (purokGroup.rows.length > 0) {
            if (index > 0) {
              doc.addPage();
            }

            doc.setFontSize(8);
            doc.text('BNS Form No. 1A', 40, 40);
            doc.setFontSize(7);
            doc.text('Philippine Plan of Action for Nutrition', 40, 50);
            doc.setFontSize(15);
            doc.text(`FAMILY PROFILE`, 350, 70);
            doc.setFontSize(10);
            doc.text(`Barangay: ${barangayName}`, 40, 80);
            doc.text(`Municipality: ${municipalName}, ${provinceName}`, 650, 80);

            doc.setFontSize(10);
            doc.text(`Purok / Sitio: ${purokGroup.purok}`, 40, 95);

            autoTable(doc, {
              startY: 100,
              head: form1AHead,
              body: purokGroup.rows,
              theme: 'plain', // 'striped', 'grid', 'plain'
              tableWidth: 'auto',
              styles: {
                fontSize: 7,
                cellPadding: 2,
                halign: "center",
                overflow: 'linebreak',
                minCellHeight: 22,
                lineWidth: { top: 0, bottom: 0.1, left: 0, right: 0 }, 
                lineColor: [0, 0, 0]
              },
              headStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                halign: "center",
                overflow: 'linebreak',
                valign: 'middle',
                fontSize: 7,
                lineWidth: 0.5,
                lineColor: [0, 0, 0]
              },
              columnStyles: form1AColumnStyles,
            });
          }
        });
        return doc;

      case "BNS Form 1B":
        head = [
          [
            { content: "HH\nNo.", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "Name of Household Head/Spouse", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "Name of Child", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "Date of Birth\n(mm/dd/yyyy)", rowSpan: 1, colSpan: 1, styles: { valign: 'middle' } },
            { content: "Age in months", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "Height (cm)", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "Weight (kg)", rowSpan: 2, styles: { valign: 'middle' } },
            { content: "NUTRITIONAL STATUS", colSpan: 3, styles: { halign: 'center', valign: 'middle' } },
            { content: "Practicing EBF if\nchild is <6\nmos old\n(Y/N)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "SOLID FOOD FEEDING", colSpan: 3, styles: { halign: 'center', valign: 'middle' } },
            { content: "MICRONUTRIENT\nSUPPLEMENTATION", colSpan: 3, styles: { halign: 'center', valign: 'middle' } }
          ],
          [
            "Date of OPT Plus\n(mm/dd/yyyy)",
            "Weight\nfor\nAge",
            "Length/\nHeight\nfor Age",
            "Weight\nfor\nLength/\nHeight",
            "Practicing CF\n(6-23 mos)\n(Y/N)",
            "Age in\nmonths\n started CF",
            "beneficiary\nof SF\n(Y/N)",
            "Vitamin A\nlast date\nreceived\n (Y/N)",
            "Iron\nreceived\n(Y/N)",
            "Using\nMNP\n(Y/N)"
          ]
        ];

        columnStyles = {
          0: { cellWidth: 20, halign: 'center' },
          1: { halign: 'left' },
          2: { halign: 'left' },
          3: { cellWidth: 45, halign: 'center' },
          4: { cellWidth: 25, halign: 'center' },
          5: { cellWidth: 30, halign: 'center' },
          6: { cellWidth: 30, halign: 'center' },
          7: { cellWidth: 30, halign: 'center' },
          8: { cellWidth: 30, halign: 'center' },
          9: { cellWidth: 30, halign: 'center' },
          10: { cellWidth: 40, halign: 'center' },
          11: { cellWidth: 40, halign: 'center' },
          12: { cellWidth: 30, halign: 'center' },
          13: { cellWidth: 40, halign: 'center' },
          14: { cellWidth: 40, halign: 'center' },
          15: { cellWidth: 30, halign: 'center' },
          16: { cellWidth: 30, halign: 'center' },
        };

        (reportData[label] || []).forEach((purokGroup, index) => {
            if (purokGroup.rows.length > 0) {
                if (index > 0) {
                    doc.addPage();
                }

                doc.setFontSize(8);
                doc.text('BNS Form No. 1B', 40, 40);
                doc.setFontSize(7);
                doc.text('Philippine Plan of Action for Nutrition', 40, 50);
                doc.setFontSize(15);
                doc.text(`FAMILY PROFILE`, 350, 70);
                doc.setFontSize(10);
                doc.text(`Barangay: ${barangayName}`, 40, 80);
                doc.text(`Municipality: ${municipalName}, ${provinceName}`, 650, 80);

                doc.setFontSize(10);
                doc.text(`Purok / Sitio: ${purokGroup.purok}`, 40, 95);

                autoTable(doc, {
                    startY: 100,
                    head: head,
                    body: purokGroup.rows,
                    theme: 'grid', // 'striped', 'grid', 'plain'
                    tableWidth: 'auto',
                    avoidRowSplit: true,
                    styles: {
                        fontSize: 7,
                        cellPadding: 2,
                        halign: "center",
                        overflow: 'linebreak',
                        valign: 'middle',
                        minCellHeight: 22,
                        lineColor: [0, 0, 0]
                    },
                    headStyles: {
                        fillColor: [255, 255, 255],
                        textColor: [0, 0, 0],
                        halign: "center",
                        overflow: 'linebreak',
                        valign: 'middle',
                        fontSize: 7,
                        lineWidth: 0.5,
                        lineColor: [0, 0, 0]
                    },
                    columnStyles: columnStyles,
                });
            }
        });
        return doc;

      case "OPT Plus Form 1B":
        doc.setFontSize(10);
        doc.text('Republic of the Philippines', doc.internal.pageSize.width / 2, 30, { align: 'center' });
        doc.text('Department of Health', doc.internal.pageSize.width / 2, 42, { align: 'center' });
        doc.setFontSize(12);
        doc.text('NATIONAL NUTRITION COUNCIL', doc.internal.pageSize.width / 2, 54, { align: 'center' });

        doc.setFontSize(10);
        doc.text('OPT Plus Form 1B: List of Affected/At-risk Preschoolers 0-71 Months old', 40, 80);
        doc.setFontSize(8);
        doc.text('Revised February 2012', 40, 90);

        doc.setFontSize(10);
        doc.text(`Barangay: \t ${barangayName}`, 40, 105);
        doc.text(`City/Municipal, Province:${municipalName}, ${provinceName}`, 260, 105);
        doc.text(`Year/Period of Measurement:`, 550, 105);
        doc.line(90,110,200,110)
        doc.line(370,110,480,110)
        doc.line(680,110,750,110)

        doc.setFontSize(8);
        doc.text('Instructions:', 40, 130);
        doc.text('In column 1, copy the household number from the Family Profile.\nIn column 2, write the family name first, followed by name of the household head.\nIn column 3, write the first name of the preschool child.\nIn column 4, write "B" for boy and "G" for girl.', 40, 140, { maxWidth: 300 });

        doc.text('In column 5, specify if household members belong to an indigenous people group; write "NA" if not applicable.\nIn column 6, indicate the age in months based on last completed month.\nIn column 7-14, check the appropriate nutritional status.\nFor the TOTAL ROW, add all values in each column.', 400, 140, { maxWidth: 350 });

        head = [
          [
            { content: "Purok", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Household\nNumber\n(1)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Name of Household Head/Caregiver\n(2)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Name of Preschooler\n(3)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Sex\n(4)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Indigenous\nGroup\n(5)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Age in\nMonths\n(6)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Nutritional Status", colSpan: 8, styles: { halign: 'center', valign: 'middle' } }
          ],
          [
            { content: "UW\n(7)", styles: { halign: 'center' } },
            { content: "SUW\n(8)", styles: { halign: 'center' } },
            { content: "St\n(9)", styles: { halign: 'center' } },
            { content: "SSt\n(10)", styles: { halign: 'center' } },
            { content: "W\n(11)", styles: { halign: 'center' } },
            { content: "SW\n(12)", styles: { halign: 'center' } },
            { content: "OW\n(13)", styles: { halign: 'center' } },
            { content: "OW\n(14)", styles: { halign: 'center' } },
          ]
        ];

        bodyData = reportData[label] || [];

        columnStyles = {
          0: { cellWidth: 50, halign: 'center' },
          1: { cellWidth: 60, halign: 'center' },
          4: { cellWidth: 30, halign: 'center' },
          5: { cellWidth: 50, halign: 'center' },
          6: { cellWidth: 40, halign: 'center' },
          7: { cellWidth: 30, halign: 'center' },
          8: { cellWidth: 30, halign: 'center' },
          9: { cellWidth: 30, halign: 'center' },
          10: { cellWidth: 30, halign: 'center' },
          11: { cellWidth: 30, halign: 'center' },
          12: { cellWidth: 30, halign: 'center' },
          13: { cellWidth: 30, halign: 'center' },
          14: { cellWidth: 30, halign: 'center' },
        };

        autoTable(doc, {
          startY: 190,
          head,
          body: bodyData,
          theme: 'grid', // 'striped', 'grid', 'plain'
          tableWidth: 'auto',
          avoidRowSplit: true,
          styles: {
            fontSize: 7,
            cellPadding: 2,
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            minCellHeight: 22,
            lineColor: [0, 0, 0]
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            fontSize: 7,
            lineWidth: 0.5,
            lineColor: [0, 0, 0]
          },
          columnStyles: columnStyles,
          margin: { top: 40, right: 40, bottom: 60, left: 40 },
        });

        doc.setFontSize(9);
        doc.text('Prepared by:', 40, doc.internal.pageSize.height - 50);
        doc.line(100,doc.internal.pageSize.height - 50, 300, doc.internal.pageSize.height - 50)
        doc.text('Name and Signature of Barangay Nutrition Scholar', 100, doc.internal.pageSize.height - 40);
        doc.text('Date:', 70, doc.internal.pageSize.height - 20);

        doc.text('Checked:', doc.internal.pageSize.width / 2 - 90, doc.internal.pageSize.height - 50);
        doc.line(doc.internal.pageSize.width / 2 - 50,doc.internal.pageSize.height - 50, doc.internal.pageSize.width / 2 + 150, doc.internal.pageSize.height - 50)
        doc.text('Name and Signature of Midwife/Nurse/District/City', doc.internal.pageSize.width / 2 - 50, doc.internal.pageSize.height - 40);
        doc.text('Nutrition Program Coordinator', doc.internal.pageSize.width / 2 - 20, doc.internal.pageSize.height - 30);
        doc.text('Date:', doc.internal.pageSize.width / 2 - 75, doc.internal.pageSize.height - 10);

        doc.text('Approved:', doc.internal.pageSize.width - 250, doc.internal.pageSize.height - 60);
        doc.line(doc.internal.pageSize.width - 50,doc.internal.pageSize.height - 50, doc.internal.pageSize.width - 200, doc.internal.pageSize.height - 50)
        doc.text('Name and Signature of Barangay', doc.internal.pageSize.width - 200, doc.internal.pageSize.height - 40);
        doc.text('Captain, BNC Chairperson', doc.internal.pageSize.width - 180, doc.internal.pageSize.height - 30);
        doc.text('Date:', doc.internal.pageSize.width - 231, doc.internal.pageSize.height - 10);

        return doc;

      case "BNS Form No. 3A":
        doc.setFontSize(10);
        doc.text('MONTHLY RECORD OF WEIGHT AND WEIGHT STATUS', doc.internal.pageSize.width / 2, 60, { align: 'center' }); 
        doc.text('INFANTS 0 - 23 MONTHS', doc.internal.pageSize.width / 2, 75, { align: 'center' }); 

        let currentY = 100;

        // Combined Barangay, City/Municipality, and Province
        const bns3aBarangayVal = barangayName;
        const bns3aCityMunicipalityVal = municipalName;
        const bns3aProvinceVal = provinceName;
        const combinedLocationText = `Barangay: ${bns3aBarangayVal}, ${bns3aCityMunicipalityVal}, ${bns3aProvinceVal}`;
        
        doc.setFontSize(9);
        doc.text(combinedLocationText, 40, currentY);

        currentY += 15;

        head = [
          [
            { content: "No.", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Name of Child", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Birthdate", colSpan:1, styles: { valign: 'middle', halign: 'center' } },
            { content: "1st Weighing", colSpan: 3, styles: { halign: 'center', valign: 'middle' } },
            { content: "2nd Weighing", colSpan: 3, styles: { halign: 'center', valign: 'middle' } },
            { content: "3rd Weighing", colSpan: 3, styles: { halign: 'center', valign: 'middle' } },
          ],
          [
            "MM/DD/YYYY",
            "Age\nmonths", "Weight\n(kg)", "Status",
            "Age\nmonths", "Weight\n(kg)", "Status",
            "Age\nmonths", "Weight\n(kg)", "Status",
          ]
        ];

        bodyData = reportData[label] || [];

        columnStyles = {
          0: { cellWidth: 30, halign: 'center' },
          2: { cellWidth: 60, halign: 'center' },
          3: { cellWidth: 40, halign: 'center' },
          4: { cellWidth: 40, halign: 'center' },
          6: { cellWidth: 40, halign: 'center' },
          7: { cellWidth: 40, halign: 'center' },
          9: { cellWidth: 40, halign: 'center' },
          10: { cellWidth: 40, halign: 'center' },
        };

        autoTable(doc, {
          startY: currentY + 5,
          head,
          body: bodyData,
          theme: 'grid', // 'striped', 'grid', 'plain'
          tableWidth: 'auto',
          avoidRowSplit: true,
          styles: {
            fontSize: 10,
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            minCellHeight: 22,
            lineColor: [0, 0, 0]
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            fontSize: 8,
            lineWidth: { top: 0, bottom: 0.1, left: 0, right: 0 }, 
            lineColor: [0, 0, 0]
          },
          columnStyles: columnStyles,
          margin: { top: 90, right: 40, bottom: 60, left: 40 },
        });
        return doc;

      // Group 1: Reports with dynamic last column header
      case "Underweight Children Without Sanitary Toilet":
      case "Underweight Children with Large (>5) Family Size":
      case "Underweight Children Without Potable Water Supply": 
      case "Underweight Children Without Proper Garbage Disposal":
      case "Malnourished Children with family per capita income below poverty threshold but above food threshold":
      case "Malnourished Children with family per capita income below food threshold":
        doc.setFontSize(8);
        doc.text(nncReportTitles[label], doc.internal.pageSize.width / 2, 50, { align: 'center' }); // Re-added nncReportTitles[label]
        doc.setFontSize(10);
        doc.text(`(${label})`, doc.internal.pageSize.width / 2, 60, { align: 'center' }); 
        
        // Add current day and date below the dynamic title
        doc.setFontSize(9);
        doc.text(getFormattedDate(), doc.internal.pageSize.width / 2, 75, { align: 'center' });

        let newReportsCurrentY = 90; // Start Y for this section

        // Combined Barangay, City/Municipality, and Province
        const nncBarangayVal = barangayName;
        const nncCityMunicipalityVal = municipalName;
        const nncProvinceVal = provinceName;
        const nncCombinedLocationText = `Barangay: ${nncBarangayVal}, ${nncCityMunicipalityVal}, ${nncProvinceVal}`;
        
        doc.setFontSize(9);
        doc.text(nncCombinedLocationText, 40, newReportsCurrentY);
        newReportsCurrentY += 5; 

        // Determine the last column header dynamically for this group
        let dynamicLastColumnHeader = "";
        switch (label) {
            case "Underweight Children Without Sanitary Toilet":
                dynamicLastColumnHeader = "Uri ng Palikuran";
                break;
            case "Underweight Children with Large (>5) Family Size":
                dynamicLastColumnHeader = "Laki ng Pamilya"; 
                break;
            case "Underweight Children Without Potable Water Supply":
                dynamicLastColumnHeader = "Pinagkukunan ng Tubig";
                break;
            case "Underweight Children Without Proper Garbage Disposal":
                dynamicLastColumnHeader = "Paraan ng Pagtatapon ng Basura";
                break;
            case "Malnourished Children with family per capita income below poverty threshold but above food threshold":
            case "Malnourished Children with family per capita income below food threshold":
                dynamicLastColumnHeader = "Per Capita Income Status"; 
                break;
            default:
                dynamicLastColumnHeader = "Facility Type"; // Fallback, though should be covered by cases
        }

        head = [
          [
            { content: "Purok", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Numero ng Bahay", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Street", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Pangalan ng Puno ng Pamilya", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Pangalan ng Bata", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Edad(mos)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Nutritional Status", colSpan: 3, styles: { halign: 'center', valign: 'middle' } },
            { content: dynamicLastColumnHeader, rowSpan: 2, styles: { valign: 'middle', halign: 'center' } }
          ],
          [
            { content: "WA", styles: { halign: 'center' } },
            { content: "HA", styles: { halign: 'center' } },
            { content: "WH", styles: { halign: 'center' } }
          ]
        ];
        
        // Define column styles for this group (similar to before, but the last column header is dynamic)
        columnStyles = {
          0: { cellWidth: 50, halign: 'center' }, // Purok
          1: { cellWidth: 50, halign: 'center' }, // Numero ng Bahay
          2: { cellWidth: 80 }, // Street
          5: { cellWidth: 60, halign: 'center' }, // Edad(mos)
          6: { cellWidth: 40, halign: 'center' }, // WA
          7: { cellWidth: 40, halign: 'center' }, // HA
          8: { cellWidth: 40, halign: 'center' }, // WH
        };

        autoTable(doc, {
          startY: newReportsCurrentY + 5,
          head: head,
          body: bodyData, 
          tableWidth: 'auto',
          theme: 'plain',
          avoidRowSplit: true,
          styles: {
            fontSize: 8,
            cellPadding: 2,
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            minCellHeight: 20,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            fontSize: 8,
            lineWidth: { top: 0, bottom: 0.1, left: 0, right: 0 }, 
            lineColor: [0, 0, 0]
          },
          columnStyles: columnStyles,
        });
        return doc;

      // Group 2: Reports with last column removed
      case "Underweight Children with Incomplete Immunization, 12-23 months":
      case "Underweight Children with No Immunization, 0-1 months":
      case "Underweight Children Not Dewormed":
      case "Underweight Children Without Backyard Garden":
        doc.setFontSize(8);
        doc.text(nncReportTitles[label], doc.internal.pageSize.width / 2, 50, { align: 'center' }); // Re-added nncReportTitles[label]
        doc.setFontSize(10);
        doc.text(`(${label})`, doc.internal.pageSize.width / 2, 60, { align: 'center' }); 
        
        // Add current day and date below the dynamic title
        doc.setFontSize(9);
        doc.text(getFormattedDate(), doc.internal.pageSize.width / 2, 75, { align: 'center' });

        let newReportsCurrentYNoLastCol = 90; // Start Y for this section

        // Combined Barangay, City/Municipality, and Province
        const nncBarangayValNoLastCol = barangayName;
        const nncCityMunicipalityValNoLastCol = municipalName;
        const nncProvinceValNoLastCol = provinceName;
        const nncCombinedLocationTextNoLastCol = `Barangay: ${nncBarangayValNoLastCol}, ${nncCityMunicipalityValNoLastCol}, ${nncProvinceValNoLastCol}`;
        
        doc.setFontSize(9);
        doc.text(nncCombinedLocationTextNoLastCol, 40, newReportsCurrentYNoLastCol);
        newReportsCurrentYNoLastCol += 5; 

        head = [
          [
            { content: "Purok", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Numero ng Bahay", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Street", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Pangalan ng Puno ng Pamilya", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Pangalan ng Bata", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Edad(mos)", rowSpan: 2, styles: { valign: 'middle', halign: 'center' } },
            { content: "Nutritional Status", colSpan: 3, styles: { halign: 'center', valign: 'middle' } },
            // Removed the last column header
          ],
          [
            { content: "WA", styles: { halign: 'center' } },
            { content: "HA", styles: { halign: 'center' } },
            { content: "WH", styles: { halign: 'center' } }
          ]
        ];

        // Adjust columnStyles to remove the last column's styling
        columnStyles = {
          0: { cellWidth: 50, halign: 'center' }, // Purok
          1: { cellWidth: 50, halign: 'center' }, // Numero ng Bahay
          2: { cellWidth: 80 }, // Street
          5: { cellWidth: 60, halign: 'center' }, // Edad(mos)
          6: { cellWidth: 40, halign: 'center' }, // WA
          7: { cellWidth: 40, halign: 'center' }, // HA
          8: { cellWidth: 40, halign: 'center' }, // WH
        };

        // bodyData is already structured correctly by fetchData for these reports
        console.log(bodyData)
        autoTable(doc, {
          startY: newReportsCurrentYNoLastCol + 5,
          head: head,
          body: bodyData, 
          theme: 'plain',
          tableWidth: 'auto',
          avoidRowSplit: true,
          styles: {
            fontSize: 8,
            cellPadding: 2,
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            minCellHeight: 20,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            fontSize: 8,
            lineWidth: { top: 0, bottom: 0.1, left: 0, right: 0 }, 
            lineColor: [0, 0, 0]
          },
          columnStyles: columnStyles,
        });
        return doc;

      default:
        let defaultBody = [["Invalid form type or no data available"]];
        head = [["Notice"]];
        autoTable(doc, {
          startY: 100,
          head,
          body: defaultBody,
          tableWidth: 'auto',
          avoidRowSplit: true,
          styles: {
            fontSize: 7,
            cellPadding: 2,
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            minCellHeight: 22,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            halign: "center",
            overflow: 'linebreak',
            valign: 'middle',
            fontSize: 7,
            lineWidth: 0.5,
            lineColor: [0, 0, 0]
          },
          columnStyles: columnStyles,
        });
        return doc;
    }
  };


  const reportTypes = [
    "Family Profile (BNS Form No. 1A) complete enumeration",
    "Family Profile (BNS Form No. 1A) with children < 6",
    "BNS Form 1B",
    "OPT Plus Form 1B",
    "BNS Form No. 3A",
  ];

  if (loading) {
    return (
      <div style={pageContainer}>
        <div style={reportContainer}>
          <h2 style={heading}>Loading Nutrition Reports...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={pageContainer}>
        <div style={reportContainer}>
          <h2 style={heading}>Error: {error.message}</h2>
          <p>Please ensure your backend server is running and accessible and returning valid JSON.</p>
        </div>
      </div>
    );
  }

  const disabledButtonStyles = {
    backgroundColor: '#cccccc',
    cursor: 'not-allowed',
    color: '#666666'
  };

  // isNNCActionDisabled now depends on isSearchApplied from props
  const isNNCActionDisabled = !isSearchApplied || !selectedNNCForm;

  return (
    <div style={pageContainer}>
      {/* Removed local search input and apply search button */}
      <div style={reportContainer}>
        <h2 style={heading}>Generate Nutrition Reports</h2>
        
        <div style={reportCardsContainer}>
          {reportTypes.map((label, i) => {
            // Buttons for initial reports are disabled if search is not applied
            const isDisabled = !isSearchApplied;
            return (
              <div key={i} style={card}>
                <h3>{label}</h3>
                <button
                  onClick={() => handlePreview(label)}
                  style={{
                    ...button,
                    marginRight: "10px",
                    ...(isDisabled ? disabledButtonStyles : {})
                  }}
                  disabled={isDisabled}
                >
                  View
                </button>
                <button
                  onClick={() => handleDownload(label)}
                  style={{
                    ...button,
                    ...(isDisabled ? disabledButtonStyles : {})
                  }}
                  disabled={isDisabled}
                >
                  Download
                </button>
              </div>
            );
          })}

          {/* New dropdown for NNC Forms */}
          <div style={{ ...card, flex: '1 1 100%', maxWidth: 'calc(100% - 40px)', marginTop: '20px' }}>
            <h3>Additional Nutrition Forms</h3> 
            <div style={{ marginBottom: '15px' }}>
              <label htmlFor="nncFormSelect" style={{ marginRight: '10px', fontSize: '16px' }}>Select Form:</label>
              <select
                id="nncFormSelect"
                value={selectedNNCForm}
                onChange={(e) => {
                  setSelectedNNCForm(e.target.value);
                }}
                style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', width: '250px' }}
                disabled={!isSearchApplied} // Disable dropdown if search not applied
              >
                <option value="">-- Select a Form --</option>
                {nncReportTypes.map((formName, idx) => (
                  <option key={idx} value={formName}>{formName}</option>
                ))}
              </select>
            </div>
            <button
              onClick={() => handleNNCFormAction('preview')}
              style={{
                ...button,
                marginRight: "10px",
                ...(isNNCActionDisabled ? disabledButtonStyles : {})
              }}
              disabled={isNNCActionDisabled}
            >
              View Selected
            </button>
            <button
              onClick={() => handleNNCFormAction('download')}
              style={{
                ...button,
                ...(isNNCActionDisabled ? disabledButtonStyles : {})
              }}
              disabled={isNNCActionDisabled}
            >
              Download Selected
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Styling (remains the same)
const pageContainer = {
  // Removed marginTop as Header is now in parent
  minHeight: "calc(100vh - 0px)", // Adjusted minHeight
  backgroundColor: "#f8f9fa",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%", // Ensure it takes full width of parent
};

const reportContainer = {
  width: "100%", // Adjusted to fill parent's width
  backgroundColor: "#ffffff",
  padding: "30px",
  borderRadius: "10px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
};

const heading = {
  fontSize: "24px",
  fontWeight: "bold",
  marginBottom: "20px",
  textAlign: "center",
  color: "#333",
};

const reportCardsContainer = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
  gap: "20px",
};

const card = {
  marginBottom: "20px",
  padding: "15px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  backgroundColor: "#fefefe",
  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
  flex: "1 1 calc(20% - 40px)",
  minWidth: "280px",
  maxWidth: "calc(50% - 20px)",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
};

const button = {
  padding: "10px 20px",
  backgroundColor: "#007bff",
  color: "#fff",
  border: "none",
  borderRadius: "5px",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
  transition: 'background-color 0.3s ease',
};

const disabledButtonStyles = {
  backgroundColor: '#cccccc',
  cursor: 'not-allowed',
  color: '#666666',
};

export default NutritionReports;